import { REACTIONS_API_ENDPOINT } from '@/constants';
import { io } from 'socket.io-client';


export class ReactionsService {

  /**
   * ### Reactions Service
   * Service to interface with the Reactions Server.
   * Use this to send and receive reactions over websocket
   * connections
   * 
   * ---
   * @param {*} onMessageCallback Callback to invoke on messsage
   *                              from the websocket server
   */
  constructor(onMessageCallback) {
    this.socket = io(REACTIONS_API_ENDPOINT);
    
    this.createHooks(onMessageCallback);
  }

  /**
   * Creates the hooks for the events generated by the websocket server
   * ---
   * @param {*} onMessageCallback Callback to invoke on messsage
   *                              from the websocket server
   */
  createHooks(onMessageCallback) {
    // Create Listeners for Web Socket events
    this.socket.on('connect',()  => {
      console.log('CONNECTED TO REACTIONS WEB SOCKET: ');
    });

    this.socket.on('reaction', (emojiId) => {
      // Callback for displaying message received
      onMessageCallback(emojiId);
    });

    this.socket.on('disconnect', (reason) => {
      console.log('REACTIONS SERVER DISCONNECTED DUE TO ', reason);
    });
  
    this.socket.on ('connect_error',(error) => {
      console.error('REACTIONS CONNECTION ERROR: ', error);
    });  
  }

  /**
   * Send a new Reaction over the websocket connection to
   * the server
   * ---
   * @param {*} emojiId The emoji to send as reaction 
   *                    to the websocket server
   */
  send(emojiId) {
    this.socket.emit('reaction', emojiId);
  }

  /**
   * Closes the connection to the websocket server
   */
  close() {
    this.socket.close();
  }
}
